import { get } from 'lodash-es';

import type { Optional } from '@zen/utils/typescript';

const checkPermission = <T>(permissionObject: Optional<T>, key: keyof T): boolean =>
  Boolean(get(permissionObject, `${String(key)}.value`, false));

export { checkPermission };
